<!-- eslint-disable max-len -->
<template>
  <div
    class="spa-soft-header-detail"
  >
    <div class="spa-soft-header-detail-wrapper">
      <div class="spa-soft-header-detail-left">
        <div class="spa-name">
          {{ propertyData.facilityName }}
        </div>
      </div>
      <div
        v-if="showDateAndGuestCta"
        class="spa-soft-header-detail-right"
      >
        <div class="spa-soft-header-detail-info">
          <div class="date-wrapper">
            <button
              type="button"
              class="selected-date"
              @click.prevent="handleClick"
            >
              {{ selectedDateFormatted }}
            </button>
          </div>
          <div class="marker" />
          <button
            type="button"
            class="selected-guests"
            @click.prevent="handleClick"
          >
            {{ numberOfAdultsLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SPA_SOFT_ROUTE_NAMES } from '@components/07.spa-soft/spa-soft/routes/spa-soft-routes'
  import { mapState, mapGetters } from 'vuex'
  import { formatDateZone } from '@utils/date-helpers'
  import { capitalize } from '@utils/string-helpers'

  export default {
    name: 'SpaSoftHeaderDetail',
    computed: {
      ...mapState('spaSoft', ['step', 'selectedDate', 'numberOfGuests', 'propertyData']),
      ...mapGetters('i18n', ['tc']),
      showDateAndGuestCta() {
        return this.step !== 0
      },
      selectedDateFormatted() {
        return formatDateZone(this.selectedDate, null, 'dddd, D MMMM, YYYY')
      },
      numberOfAdultsLabel() {
        const adultWord = this.numberOfGuests > 1 ? this.tc('noums.adultPlural') : this.tc('noums.adultSingular')
        return `${this.numberOfGuests} ${capitalize(adultWord)}`
      }
    },
    methods: {
      handleClick(e) {
        const focusTarget = e.target.classList.contains('selected-date') ? 'date' : 'guests'
        this.$router.push({
          name: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE,
          params: { focusOn: focusTarget },
          query: {
            ...this.$route.query,
          }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
    }
  }
</script>
